
<template>
	<div class="content" @click="$emit('click')">
		<div class="notice">{{ notice }}</div>
		<img class="logo" :src="logo" alt="">
		<div class="main">
			<div class="flex-box font-main item">
				<span class="van-multi-ellipsis--l2 font-name">{{ name }}</span>
			</div>
			<div class="flex-box font-main item">
				<span class="border">VIP{{ vip }}</span>
				<span class="border">{{ day }}{{ returnCy() }}</span>
			</div>
			<div class="flex-box item">
				<span class="font-main">${{ amount }}</span>
				<span class="font-sub">{{ $t('lang.利率') }} {{ rate }}%</span>
			</div>
			<div class="progress">
                <van-progress :percentage="used/total*100" stroke-width="8" color="#be9f82"/>

<!--                <div class="info">{{ percent }}%</div>-->
			</div>
			<div class="item">
				<span class="font-sub font-size-">{{ $t('lang.已购') }}/{{ $t('lang.限购') }} {{used}}/{{total}}</span>
			</div>
		</div>
	</div>
</template>


<script>
export default {
	props:{
		vip: '',
		name: '',
		day: '',
		amount: '',
		rate: '',
		used: '',
		total: '',
		percent: '',
        logo: "",
        ms: '',
	},
    computed:{
        notice(){
            if( this.ms === 0){
                return this.$t('lang.notice')
            }else if(this.ms === 1){
                return this.$t('lang.notice1')
            }else if(this.ms === 2){
                return this.$t('lang.notice2')
            }
        }
    },
    methods:{
        returnCy(){
            let msg = ''
            let ms = this.ms;
            switch (ms) {
                case 0:
                    msg = this.$t('utils.day')
                    break;
                case 1:
                    msg = this.$t('lang.小时');
                    break;
                case 2:
                    msg = this.$t('utils.day')
                    break;
                default:
                    break;
            }
            return msg;
        },
    }
}
</script>


<style scoped lang="less">
.font-name{
  display: inline-block;
  padding: 2px 0;
  font-size: 12px;
}
.flex-box{
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.font-main{
	color: #dccfc7;
	font-size: 12px;
}
.font-sub{
  font-size: 12px;
	color: #8c7f77;
}
.font-size-sub{
	font-size: 16px;
}
.content{
	display: flex;
	flex-direction: column;
	position: relative;
	background: #281B13;
	border-radius: 8px;
	overflow: hidden;
	.notice{
      font-size: 12px;
		padding-left: 28px;
		padding-right: 4px;
		width: auto;
		height: 26px;
		line-height: 26px;
		text-align: right;
		position: absolute;
		top: 0;
		right: 0;
		background-image: url("../../assets/img/item-notice.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}

	.logo{
		width: auto;
		height: 118px;
	}

	.main{
		 padding: 10px;
		.item{
			margin: 10px 0;
			.border{
				white-space: nowrap;
				width: 50px;
				border: 1px solid #8c7f77;
				border-radius: 4px;
				padding: 4px 8px;
			}
		}
		.progress{
			margin-top: 24px;
			margin-bottom: 16px;
			height: 12px;
			//background-color: #0a0c07;
			position: relative;
			.info{
				border-radius: 12px;
				position: absolute;
				top: 50%;
				transform: translateY(-50%);
				left: 0;
				padding: 4px 6px;
				color: #FFFFFF;
				background-color: #be9f82;
			}
		}
	}
}
</style>
